import { render, staticRenderFns } from "./ImportDetailInfo.vue?vue&type=template&id=4e1bee2e&"
import script from "./ImportDetailInfo.vue?vue&type=script&lang=ts&"
export * from "./ImportDetailInfo.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports